import { Box, styled } from '@mui/material';

// Define type-safe prop for size
type CustomBadgeProps = {
  size?: 'small' | 'large';
};

export const TaBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<CustomBadgeProps>(({ theme, size = 'small' }) => {
  const stylesBySize = {
    small: {
      height: '26px',
      fontSize: '12px',
      gap: '6px',
      padding: '5px 12px',
      fontWeight: 500,
      lineHeight: '14px',
      borderRadius: '10px',
    },
    large: {
      height: '42px',
      fontWeight: 500,
      gap: '7px',
      fontSize: '14px',
      padding: '4px 8px',
      lineHeight: '16px',
      borderRadius: theme.borderRadius?.borderRadiusXSmall,
    },
  };

  return {
    width: 'fit-content',
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'center',
    ...stylesBySize[size],
  };
});

export const SuccessBadge = styled(TaBadge)(({ theme }) => ({
  background: theme.colors.success.light,
  color: theme.colors.success.text,
}));

export const ErrorBadge = styled(TaBadge)(({ theme }) => ({
  background: theme.colors.error.lighter,
  color: theme.colors.error.text,
}));

export const GrayBadge = styled(TaBadge)(({ theme }) => ({
  color: theme.text?.subText2,
  background: theme.background?.surfaceDark,
}));
